import { friendAvatar2 } from "utils/assets_exports/images";
import UserPopover from "./UserPopover";

const RePostUserBlock = () => {
    return (
        <div className="user-block">
            <div className="image p-relative">
                <img src={friendAvatar2} data-user-popover="1" alt="" />
                <UserPopover />
            </div>
            <div className="user-info">
                <a href="#">Demo User Reposted</a>
                <span className="time">July 26 2018, 01:03pm</span>
            </div>
        </div>
    );
};

export default RePostUserBlock;
